import React, {useState, useEffect} from "react";

import {
    Box,
    Divider,
    TextField,
    Grid,
    Switch,
    FormControlLabel,
    styled,
    Card,
    Select,
    MenuItem,
    FormControl,
    FormHelperText,
    InputLabel,
    Checkbox,
    ListItemText,
    OutlinedInput,
    Chip,
    List,
    ListItem, InputAdornment
} from "@mui/material";

import {LoadingButton} from "@mui/lab";
import {useNavigate} from "react-router-dom";
import {useFormik} from "formik";
import DatePickerComponent from "../../common/DatePickerComponent";
import CommonBreadcumbs from "../../common/CommonBreadcumbs";
import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonRestricted from "../../common/CommonRestricted";
import {useAppContextFeatures} from "../../../context/AppContext";

import {
    useUserApiKeys, targetTypes
} from "../../../hooks/api/useUserApiKeys";
import {useSystemRoutes, routeTypes} from "../../../hooks/useSystemRoutes";
import {
    useUserRoles, roleTypes, targetTypes as roleTargetTypes
} from "../../../hooks/api/useUserRoles";
import {useTranslations} from "../../../hooks/useTranslations";

import {
    useLocations, locationTypes, targetTypes as locationTargetTypes
} from "../../../hooks/api/useLocations";
import {useSystemPrompt} from "../../../hooks/useSystemPrompt";
import {
    initialValues,
    validationSchema
} from "../../../schema/userApiKeys/userApiKeySchema";

import {useSystemHead, headTitles} from "../../../hooks/useSystemHead";
import {
    usePermissions, scopeIds, scopeTypes, functionTypes
} from "../../../hooks/usePermissions";
import SearchAdministrators from "../../dialog/SearchAdministrators";
import {checkValueExists} from "../../../utils/dataSchema";

const StyledCard = styled (Card) (({theme}) => ({
    padding: theme.spacing (2)
}));

export default function NewUserApiKey ({
    routeType
}) {
    const {t} = useTranslations ({ns: ["common", "@userApiKey"]});

    const {promptMessage} = useSystemPrompt ();
    const {setSystemLoading} = useAppContextFeatures ();

    const {isLoading, create, filterOperatorTypes} = useUserApiKeys({ targetType: targetTypes.userApiKey });

    const {list: listLocation} = useLocations ({ 
        locationType: locationTypes.location, 
        targetType: targetTypes.location 
    });

    const {list: userRoleList} = useUserRoles ({ roleType: roleTypes.role });
    const {isPermissionAllow} = usePermissions (routeType,
          scopeIds.userApiKey.id, scopeTypes.userApiKey.apiKey.id
    );

    const navigate = useNavigate ();
    const {getRoute} = useSystemRoutes (routeType);
    const {getHtmlHead} = useSystemHead (routeType);
    const [dataRoles, setDataRoles] = useState ();
    const onSubmit = async (currentValues) => {

        try
        {

            const {rows} = values;

            let data = {
                api_key: {
                    key_label: currentValues?.keyLabel,
                    user_id: currentValues?.userId,
                    role_id: currentValues?.roleId,
                    expiry_date: currentValues?.expiryDate.format (
                          "YYYY-MM-DD"),
                    status: currentValues?.status ? 1 : 0
                }
            };

            const response = await create ({data});

            promptMessage (true, `${response?.message}`);
            navigate (getRoute ("settings/userApiKeys"));

        } catch (error)
        {
            promptMessage (false, `Action Failed. (${error?.message})`);
        }

    };

    const formik = useFormik ({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    useEffect (() => {
        fetchDataRole ();
    }, []);

    const {values, errors, touched, handleChange, setFieldValue} = formik;

    const RenderFormProfiles = () => {
        return (
              <StyledCard sx={{mt: 1}}>

                  <Grid container spacing={0.5}>
                      <Grid item xs={6} sm={6} md={6} textAlign={"left"}>

                          <CommonSectionHeader
                                title={t (`profile`)}
                                subTitle={t (`relatedProfilesToProcess`)}
                          />

                      </Grid>
                      <Grid item xs={6} sm={6} md={6} textAlign={"right"}>

                          <Chip label={`Customer`}
                                sx={{textTransform: "capitalize"}} size="small"
                                variant="outlined" color={"primary"}/>

                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>

                          <SearchAdministrators
                                handleOnCancel={() => {

                                }}
                                handleOnSelect={(props) => {

                                    const {id, item} = props;
                                    setFieldValue ("username",
                                          item?.username
                                    );
                                    setFieldValue ("userId", item?.user_id);
                                }}
                                textProps={{
                                    disabled: true,
                                    value: values.username,
                                    error: Boolean (errors?.userId),
                                    helperText: errors?.userId
                                }}
                          />
                      </Grid>
                  </Grid>
              </StyledCard>
        );
    };

    const fetchDataRole = async (props) => {
        try
        {
            const props = {
                limit: -1,
                skip: 0,
                filterValue: [],
                sortInfo: {
                    id: "role_name"
                }
            };
            const {data} = await userRoleList (props);
            setDataRoles (data?.roles);

        } catch (error)
        {

            promptMessage (false, `Error getting results (${error?.message})`);
        }
    };
    const RenderForm = () => {
        return (

              <form onSubmit={formik.handleSubmit}>
                  <StyledCard>
                      <Grid container spacing={0.5}>
                          <Grid item xs={12} sm={12} md={3} textAlign={"left"}>

                              <CommonSectionHeader
                                    title={t ("userApiKeyInfo")}
                                    subTitle={t ("detailsOfUserApiKey")}
                              />

                          </Grid>
                          <Grid item xs={12} sm={12} md={9}>
                              <Grid container spacing={1}>
                                  <Grid item xs={12} sm={12} md={6}>
                                      <FormControlLabel
                                            sx={{
                                                marginLeft: "1px"
                                            }}
                                            control={
                                                <Switch
                                                      sx={{
                                                          mt: 1
                                                      }}
                                                      name="status"
                                                      checked={Boolean (
                                                            values.status)}
                                                      onChange={(
                                                            event, checked) => {
                                                          setFieldValue (
                                                                "status",
                                                                checked
                                                          );

                                                      }}
                                                />
                                            }
                                            label={
                                                Boolean (values.status) ?
                                                      t ("enabled") :
                                                      t ("disabled")
                                            }

                                      />
                                  </Grid>

                                  <Grid item xs={6}>
                                      {
                                          RenderFormProfiles ()
                                      }
                                  </Grid>

                                  <Grid item xs={6}>
                                      <FormControl
                                            margin="dense"
                                            fullWidth
                                            size="small"
                                            error={touched.roleId &&
                                                  Boolean (
                                                        errors.roleId)}
                                      >
                                          <InputLabel id="roleId">{t (
                                                "roleId")}</InputLabel>
                                          <Select
                                                labelId="roleId"
                                                label={t ("roleId")}
                                                name={"roleId"}
                                                onChange={(event) => {
                                                    setFieldValue (`roleId`,
                                                          event.target.value
                                                    );
                                                }}
                                                value={values.roleId}
                                                sx={{
                                                    textAlign: "left"
                                                }}
                                          >
                                              {
                                                  dataRoles?.map (
                                                        (i, index) => {
                                                            return (
                                                                  <MenuItem
                                                                        key={index}
                                                                        value={i.id}>{i.role_name}</MenuItem>
                                                            );
                                                        })
                                              }
                                          </Select>
                                          <FormHelperText>
                                              {touched.roleId &&
                                                    errors.roleId}
                                          </FormHelperText>
                                      </FormControl>
                                  </Grid>


                                  <Grid item xs={6}>
                                      <TextField
                                            margin="dense"
                                            size="small"
                                            autoFocus
                                            fullWidth
                                            name={"keyLabel"}
                                            label={t ("keyLabel")}
                                            type="text"
                                            variant="outlined"
                                            value={values.keyLabel}
                                            onChange={handleChange}
                                            error={Boolean (
                                                  errors.keyLabel)}
                                            helperText={touched.keyLabel &&
                                                  errors.keyLabel}
                                      />
                                  </Grid>


                                  <Grid item xs={6}>
                                      <DatePickerComponent
                                            config={{
                                                name: "expiryDate",
                                                label: t ("expiryDate")
                                            }}
                                            formik={{
                                                values,
                                                errors,
                                                touched,
                                                handleChange,
                                                setFieldValue
                                            }}
                                      />
                                  </Grid>
                              </Grid>
                          </Grid>
                      </Grid>
                  </StyledCard>
                  <Grid container spacing={1} sx={{pl: 2, pr: 2}}>
                      <Grid item md={12} textAlign={"right"}>
                          <LoadingButton
                                type="submit"
                                // fullWidth
                                variant="contained"
                                sx={{
                                    mt: 3,
                                    mb: 2
                                }}
                                loading={isLoading}
                          >
                              {t ("saveChanges")}
                          </LoadingButton>
                      </Grid>
                  </Grid>
              </form>

        );
    };

    return (
          <Box>
              {
                  getHtmlHead ({routeType, title: headTitles.newUserApiKey})
              }

              <CommonBreadcumbs
                    routeType={routeType}
                    pageTitle={t ("newUserApiKey")}
                    breadcrumbs={[
                        {
                            displayText: t ("userApiKeys"),
                            props: {
                                href: getRoute ("settings/userApiKeys")
                            }
                        },
                        {
                            displayText: t ("newUserApiKey"),
                            props: {
                                color: "secondary.main"
                            }
                        }
                    ]}
              />


              {
                  isPermissionAllow ({functionType: functionTypes.pageNew.id}) ?
                        RenderForm ()
                        :
                        <CommonRestricted/>
              }

          </Box>
    );
}